// extracted by mini-css-extract-plugin
export default {"root":"Card_root__LuCkd"};